import GasSafetyForm from './GasSafetyForm';
import GasSafetyPDF from './GasSafetyPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';
import templates from './templates';


// ✅ STANDARDIZED EXPORT NAMES
export default {
  Form: GasSafetyForm,        // Always export as "Form"
  PDF: GasSafetyPDF,          // Always export as "PDF"
  schema,
  validator,
  defaultData,
  transform: transformForPDF, // Map named export to "transform"
  templates
};
